import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=faa5a87c&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports